<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">Search By Version Number</span>
      </v-card-title>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>                     
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                label="Version No"
                item-text="version_no"
                item-value="id"
                v-model="version_no"
                :items="versionList"
                :rules="[v => !!v || 'Version is required !']"                
                @input="onChangeVersion(version_no)"
                >             
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <!-- /Form -->


    <v-card-title>
      <h2>Package Archive of Version No. {{version_no}}</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>


    <span style="display:none;">{{serial=serialNumber}}</span>

    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >

      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.package_no }}</td>
        <td class="text-xs-left">{{ props.item.version_no }}</td>
        <td class="text-xs-left">{{ changeFormateDMY(props.item.versioning_date) }}</td>
        <td class="text-xs-left">
          <span v-if="props.item.status_id == 1" class="active">Plan</span>
          <span v-if="props.item.status_id == 2" class="in-active">Execute</span>
          <span v-if="props.item.status_id == 3" class="active">Revision</span>
          <span v-if="props.item.status_id == 4" class="in-active">Merge</span>
          <span v-if="props.item.status_id == 5" class="in-active">Split</span>
          <span v-if="props.item.status_id == 6" class="in-active">Close</span>
          <span v-if="props.item.status_id == 7" class="in-active">Terminate</span>
          <span v-if="props.item.status_id == 8" class="in-active">Procured</span>
          <span v-if="props.item.status_id == 9" class="in-active">In-Active</span>
        </td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="addDetails(props.item)" title="Detail">
            <v-icon color="teal">view_module</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import Axios from "axios";
import ServerPath from "../../../server-path/server-path";

export default {

  data: () => ({

    version_no:'',
    versionList:[],

    valid: true,
    public_path: "",

    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },      
      {
        text: "Package Name",
        align: "left",
        sortable: true,
        value: "name"
      },
      {
        text: "Package Number",
        align: "left",
        sortable: true,
        value: "package_no"
      }, 
      { text: "Version No", align: "left", sortable: true, value: "version_no" },
      { text: "Version Date", align: "left", sortable: true, value: "versioning_date" },  
      { text: "Status", align: "left", sortable: true, value: "status_id" },  
      { text: "Action", align: "center", value: "" }
    ],
    /*------------- /Datatable ---------------*/

    delete_id: "",
    row_index: "",
    dialog2: false,
    
    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

    formSchema: {
      id: 0,
      version_no: "",
      versioning_date: "",
      document_name: "",

      projectDoc_id:0,
      document_file_name:'',
    }
  }),

  /*------------Datatable------------*/
  created() {
    this.public_path =
      ServerPath.serverPath + "/assets/midTermBudgetFramework/";
    
    commonService.getAllData("package-archive").then(res => {
        this.versionList = res.data
    })
  },

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },
  /*------------/Datatable------------*/

  methods: {
    addDetails(items)
    {
      sessionStorage.setItem("pacId", items.id); 
      sessionStorage.setItem("pacVersionId", items.package_versions_id);
      if(items.status_id == 2){
        this.$router.push('/procurement/execution-details'); 
      }else{
        //this.$router.push('/procurement/execution-details');
        this.$router.push('/procurement/archive-details');
      }
      
      
    },

    onChangeVersion()
    {
      this.getDataFromApi().then(data => {
        this.desserts = data.items;
        this.totalDesserts = data.total;
      });
    },

    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.version_no = this.version_no),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

          //.getServerSideData(query_Data, "mid-term-budget-framework-list")
        commonService
          .getServerSideData(query_Data, "package-archive-list")
          .then(res => {
            let items = res.data;

            const total = res.totalRecords;
            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    downloadFile(fileName) {
      let url = ServerPath.serverPath+fileName;
       window.open(url);      
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    editItem(index, item) {
      if (item) {        
        this.row_index = index;
        this.formSchema = {...item};

        this.formSchema.year_from_date = this.changeFormateDMY(
          this.formSchema.year_from_date
        );
        this.formSchema.year_to_date = this.changeFormateDMY(
          this.formSchema.year_to_date
        );

        //console.log("formSchema == ", this.formSchema);

        window.scrollTo({
          top: 0,
          left: 100,
          behavior: "smooth"
        });
      }
    },
    

    close(res) {
      let $this = this;
      if (res.status == 1) {
        if (res.action == "add") {
          $this.desserts.unshift({ ...res.data });
          $this.totalDesserts += 1;
        }
        if (res.action == "edit") {
          $this.$set($this.desserts, $this.row_index, { ...res.data });
          $this.row_index = "";
        }
        this.SnackbarVal.color = "success"
      }
      else
      {
        this.SnackbarVal.color = "error"
      }
      window.scrollTo({
        left: 0,
        top:
          document.body.scrollHeight || document.documentElement.scrollHeight,
        behavior: "smooth"
      });
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/procurement/package_archive/dataTable.vue